import { useMemo } from 'react';

import { CFPInputCharacters, TCFPInputCharactersProps } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';

export type AppSegmentedInputProps = Omit<TCFPInputCharactersProps, 'mask'> & {
	mask?: 'alphanumeric' | 'numeric';
};

export const AppSegmentedInput = ({ gap = 's6', size = 'xxxLarge', mask, ...props }: AppSegmentedInputProps) => {
	const inputMask = useMemo(() => {
		switch (mask) {
			case 'numeric':
				const NUMERIC_REGEX = /^[0-9]+$/;
				return { mask: '#', definitions: { '#': NUMERIC_REGEX } };
			case 'alphanumeric':
				const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
				return { mask: '#', definitions: { '#': ALPHANUMERIC_REGEX } };
			default:
				return;
		}
	}, [mask]);

	return <CFPInputCharacters inputMode="numeric" gap={gap} size={size} mask={inputMask} {...props} />;
};
